import { useEffect, useState } from "react";
import { OnePageSlider } from "reusableComponents";
import { useTranslation } from "react-i18next";
import { useLanguage } from "context/languageContext";
import { getArticles } from "services/homePage.services";
import styles from "./styles.module.scss";

const BlogAndNewsletter = () => {
  const [t] = useTranslation("global");
  const { language } = useLanguage();
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [email, setEmail] = useState("");
  const [newsletterFormUrl, setNewsletterFormUrl] = useState("");

  // Fetch articles based on language
  const fetchArticlesData = async () => {
    setLoading(true);
    setError(null);
    try {
      const fetchedArticles = await getArticles(language);
      setArticles(fetchedArticles);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Set newsletter URL based on language
  useEffect(() => {
    if (language === "com") {
      setNewsletterFormUrl(
        "//chooseandwork.us14.list-manage.com/subscribe?u=fd07364dfadb6f746a4432f54&id=6bc77d787b"
      );
    } else if (language === "be") {
      setNewsletterFormUrl(
        "//chooseandwork.us14.list-manage.com/subscribe/post?u=fd07364dfadb6f746a4432f54&id=c3e44a6298"
      );
    } else if (language === "fr") {
      setNewsletterFormUrl(
        "//chooseandwork.us14.list-manage.com/subscribe/post?u=fd07364dfadb6f746a4432f54&id=c3e44a6298"
      );
    } else if (language === "uk" || language === "es") {
      setNewsletterFormUrl(
        "//chooseandwork.us14.list-manage.com/subscribe?u=fd07364dfadb6f746a4432f54&id=6bc77d787b"
      );
    }
  }, [language]);

  useEffect(() => {
    fetchArticlesData();
  }, [language]);

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    const fullUrl = `${newsletterFormUrl}&EMAIL=${encodeURIComponent(email)}`;
    window.open(fullUrl, "_blank");
    setEmail("");
  };

  // Format date function
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString(language, { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  const articlesRenderer = articles.map((article) => (
    <div key={article.id} className={styles.articleContainer}>
      <div
        className={styles.article}
        style={{
          backgroundImage: `url(${article._embedded["wp:featuredmedia"][0].source_url})`,
        }}
      >
        {/* Date at top left */}
        <div className={styles.dateBadge}>
          {formatDate(article.date)}
        </div>
      </div>
        {/* Title in the middle */}
        <a
          href={article.link}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.link}
          aria-label={`Open ${article.title.rendered} in new tab`}
          dangerouslySetInnerHTML={{ __html: article.title.rendered }}
        />
        
        {/* Read more link at bottom */}
        <div className={styles.readMore}>
          <a 
            href={article.link} 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.readMoreLink}
          >
            → {t("buttons.readMore")} <i className="fas fa-arrow-right"></i>
          </a>
        </div>
    </div>
  ));

  return (
    <div className={`${styles.container} mediumContainer`}>
      {/* Blog Section */}
      <div className={styles.blogSection}>
        <div>
          <h3 className={styles.heading}>{t("home.tipsArticles")}</h3>
        </div>
        {loading ? (
          <div className={styles.loading}>Loading articles...</div>
        ) : error ? (
          <div className={styles.error}>{error}</div>
        ) : (
          <OnePageSlider
          // autoplay={true}
          key={`${language}-${articles.length}`}
            className={styles.slider}
            arrowTop="50%"
            arrowRight="8px"
            arrowLeft="8px"
            arrowStyle="square"
            arrowBorderColor="transparent"
          >
            {articlesRenderer}
          </OnePageSlider>
        )}
      </div>

      {/* Newsletter Section */}
      <div className={styles.newsletterSection}>
        <p className={styles.heading} dangerouslySetInnerHTML={{__html: t("footer.newsletter")}}></p>
         <p className={styles.description} >
          {t("footer.newsletterDescription")}
        </p>
        <form
          className={styles.newsletterForm}
          onSubmit={handleNewsletterSubmit}
          id="mc-embedded-subscribe-form"
        >
          <input
            type="email"
            name="EMAIL"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("footer.email")}
            className={styles.newsletterInput}
            aria-label="Email"
          />
          <button className={styles.newsletterButton} type="submit">
            {t("buttons.register")}
          </button>
        </form>
       
      </div>
    </div>
  );
};

export default BlogAndNewsletter;